﻿import { Inject, Component } from "@fiqas/angular-utils"
import { FIQAssist } from "../../app"
import { Application } from "../application"
import { AuthenticationService } from "../../services/authenticationService";
import { IsProcessingService } from "../../services/isProcessingService";
import { DialogService } from "../../services/dialogService";
import { LogService } from "../../services/logService";

@Component({
    module: FIQAssist,
    selector: "forgotPassword",
    templateUrl: "views/forgotPassword.html",
    require: {
        application: "^application"
    }
})
class ForgotPassword {
    private application: Application;
    private activeMenuItem: string;
    private email: string;
    private resetLink: string;
    private errortextemail: string = "";
    private sent: boolean = false;
    private iserror: boolean = false;

    constructor(
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject() private AuthenticationService: AuthenticationService,
        @Inject() private dialogService: DialogService,
        @Inject() private logService: LogService
    ) {

    }

    $onInit() {
        this.application.forcedCustomer = ' ';
        this.activeMenuItem = '';
        this.resetLink = this.$window.location.href.replace("forgotpassword", "newpassword?username={username}&token={token}");
    }

    $onDestroy() {
        this.application.forcedCustomer = null;
    }

    private async requestReset() {
        if (this.email.length < 5 || this.email.length > 250) {
            this.errortextemail = "WRONG_EMAIL_FORMAT";
            this.setErrorClass('email');
            this.iserror = true;
            return;
        }
        try {
            this.isProcessingService.StartProcessing();
            await this.AuthenticationService.resetPassword(this.email, this.resetLink, this.application.Settings.culture);
            this.sent = true;
        } catch (error) {
            this.application.setSeqUrl(error);
            this.logService.error('ForgotPassword', 'Error resetting password', error);
            this.dialogService.showErrorDialog('error', 'ERROR', 'PASSWORD_RESET_ERROR', { errorResult: error, translate: true })
        } finally {
            this.isProcessingService.StopProcessing();
        };
    }

    private setErrorClass(classname: string) {
        angular.element(this.$element[0].getElementsByClassName(classname).item(0)).addClass('error');
    }

    private clearErrorClass(classname: string) {
        angular.element(this.$element[0].getElementsByClassName(classname).item(0)).removeClass('error');
    }

    private onChangeEmail(value: string) {
        this.email = value;
        this.errortextemail = "";
        this.clearErrorClass('email');
        this.iserror = false;
    }

    public back() {
        this.$window.history.back();
    }

}
